<template>
    <div class="row q-col-gutter-md">
        <div class="col col-xs-12 col-md-12 col-lg-12">
            <q-select
                v-model="AccountObj.payment_method_id"
                :options="paymentMethods"
                option-value="id"
                option-label="type"
                map-options
                emit-value
                :label="$t('recipients.payment_method')"
                color="primary"
                :loading="loading_payment_methods"
                v-if="paymentMethods.length > 1"
                dir="ltr"
            />
            <q-input
                :value="paymentMethods[0]['type']"
                readonly
                :label="$t('recipients.payment_method')"
                v-else-if="paymentMethods.length === 1"
            />
            <q-skeleton type="QInput" v-else/>
        </div> <!-- ACCOUNT TYPE -->
        <div class="col col-xs-12 col-md-12 col-lg-12" v-if="instructions">
            <q-banner class="bg-grey-2" v-html="instructions">
                {{$t('instructions')}}
            </q-banner>
        </div> <!-- Instructions -->
        <div class="col col-xs-12 col-md-12 col-lg-12">
            <q-select
                v-model="AccountObj.bank_id"
                :options="banksOptions"
                use-input
                option-value="id"
                option-label="name"
                input-debounce="0"
                map-options
                emit-value
                :label="$t('recipients.bank_name')"
                color="primary"
                @filter="filterFn"
                :loading="loading_bank"
                v-if="select_bank"
            >
                <template v-slot:no-option>
                    <q-item>
                        <q-item-section class="text-grey">
                            {{$t('no_results')}}
                        </q-item-section>
                    </q-item>
                </template>
            </q-select>
        </div> <!-- BANK -->
        <div class="col col-xs-12 col-md-12 col-lg-12">
            <q-skeleton type="QInput" v-if="loading_payment_methods"/>
            <q-input
                v-model="AccountObj.number"
                :label="account_number"
                lazy-rules
                :error="AccountObj.errors.has('number')"
                :error-message="AccountObj.errors.get('number')"
                :rules="[ val => val && val.length > 0 || $t('validations.this_field_is_required')]"
                color="primary"
                v-else
                dir="ltr"
            />
        </div> <!-- ACCOUNT NUMBER -->
        <div class="col col-xs-12 col-md-12 col-lg-12">
            <q-skeleton type="QInput" v-if="loading_payment_methods"/>
            <q-input
                v-model="AccountObj.notes"
                :label="notes_label"
                :error="AccountObj.errors.has('notes')"
                :error-message="AccountObj.errors.get('notes')"
                color="primary"
                autogrow
                v-else
                dir="ltr"
            />
        </div> <!-- NOTES -->
    </div>
</template>
<script>

import Bank from "Modules/Bank/resources/models/Bank"
import OutgoingPaymentMethod from "Modules/PaymentMethod/resources/models/OutgoingPaymentMethod"

export default {
    name: "RecipientBankAccountForm",
    model: {
        prop: 'AccountObj',
        event: 'change'
    },
    props: {
        AccountObj: {
            type: Object,
            required: true
        },
        currencyAcronym: {
            type: String,
            required: true
        }
    },
    computed: {
        method() {
            return this.paymentMethods.find(item => item.id === this.AccountObj.payment_method_id)
        },
        account_number() {
            return this.method ? this.method.info_label1 : ''
        },
        notes_label() {
            return this.method && this.method.info_label2 ? this.method.info_label2 : 'Notes'
        },
        select_bank() {
            return this.method ? this.method.bank_required : false
        },
        instructions(){
            return this.method ? this.method.instructions : ''
        },
    },
    data() {
        return {
            loading_bank: false,
            loading_payment_methods: false,
            banks: [],
            paymentMethods: [],
            banksOptions: [],
            selected_method: undefined
        }
    },
    methods: {
        fetchPaymentMethods(){
            this.loading_payment_methods = true
            OutgoingPaymentMethod.list(this.currencyAcronym, (data) => {
                this.paymentMethods = data
                this.AccountObj.payment_method_id = this.paymentMethods.length ? this.paymentMethods[0]['id'] : undefined
                this.AccountObj.bank_required = this.paymentMethods.length ? this.paymentMethods[0]['bank_required'] : false
                this.loading_payment_methods = false
            }).catch(error => {
                this.$q.notify({
                    message: error.data.error,
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.loading_payment_methods = false
            })
        },
        fetchBanks() {
            this.loading_bank = true
            Bank.list(this.currencyAcronym, (data) => {
                this.banks = data
                this.loading_bank = false
            }).catch(error => {
                this.$q.notify({
                    message: error.data.error,
                    color: 'negative',
                    icon: 'fa fa-exclamation-triangle'
                })
                this.loading_bank = false
            })
        },
        filterFn (val, update) {
            if (val === '') {
                update(() => {
                    this.banksOptions = this.banks
                })
                return
            }

            update(() => {
                const needle = val.toLowerCase()
                this.banksOptions = this.banks.filter(v => v.name.toLowerCase().indexOf(needle) > -1)
            })
        }
    },
    watch: {
        method(val) {
            if(val) {
                this.AccountObj.bank_required = val.bank_required
            }
        }
    },
    mounted() {
        this.fetchPaymentMethods()
        this.fetchBanks()
    },
    components: {},
}
</script>
<style>

</style>
